import {
  Grid,
  space,
  theme,
  Typography,
} from "@waldner-laboreinrichtungen/component-system";
import { t } from "i18next";
import type { FC } from "react";
import styledComponents from "styled-components";

import type { FunctionGridProps } from "../../partials/function-grid.tsx";
import type { Channel } from "../../view-model.ts";
import {
  getPortValue,
  renderFunction,
} from "../common/function-grid-helpers.tsx";

const StyledGrid = styledComponents(Grid)`
  grid-row-gap: ${space(3)};
  grid-column-gap: ${space(1)};
  // grid-template-rows: auto 1fr 1fr;
  height: 100%;
`;

const StyledGroupContainer = styledComponents.div`
  border: 1px solid ${theme.colorPalette.grey200};
  border-radius: ${theme.borderRadius.default};
  padding: ${space(3)} ${space(2)} ${space(1)} ${space(2)};
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledGroupHeader = styledComponents(Typography)`
  position: absolute;
  top: 0;
  right: ${space(2)};
  transform: translateY(-50%);
  background: #fff;
  padding: 0 ${space(1)};
  z-index: 1;
`;

const StyledInnerGrid = styledComponents(Grid)`
  flex: 1;
  grid-row-gap: 0;
  grid-column-gap: 0;
`;

const SMART_MODULE_PORTS = ["first", "second", "third", "fourth"] as const;

// Column-first order: 1,3 (left column) then 2,4 (right column)
const SMART_MODULE_PORT_ORDER = ["first", "third", "second", "fourth"] as const;

type SmartModulePort = (typeof SMART_MODULE_PORTS)[number];

function getPort(channel: Channel): SmartModulePort | undefined {
  return getPortValue(channel, SMART_MODULE_PORTS);
}

export const FunctionGrid: FC<FunctionGridProps> = ({
  functions,
  incidents,
  onSelect,
}) => {
  const functionsByPort = new Map(
    SMART_MODULE_PORTS.map((port) => [
      port,
      functions.filter((func) => getPort(func) === port),
    ])
  );
  return (
    <StyledGrid>
      {SMART_MODULE_PORT_ORDER.map((port) => (
        <Grid.Column key={port} width={6}>
          <StyledGroupContainer>
            <StyledGroupHeader>
              <Typography color="grey500" size="sm" weight="medium">
                {t(`channel.${port}`)}
              </Typography>
            </StyledGroupHeader>
            <StyledInnerGrid>
              {(functionsByPort.get(port) ?? []).length > 0 ? (
                (functionsByPort.get(port) ?? []).map((channel) =>
                  renderFunction(channel, onSelect, 6, incidents)
                )
              ) : (
                <Typography color="grey400" size="sm">
                  {t("channel.empty")}
                </Typography>
              )}
            </StyledInnerGrid>
          </StyledGroupContainer>
        </Grid.Column>
      ))}
    </StyledGrid>
  );
};
